export const otpRegex = new RegExp(/^[0-9]*$/);
export const urlRegex = new RegExp(
  /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})(:[0-9]+)?(\/[\w \.-]*)*\/?(\?[^\s]*)?(#[^\s]*)?$/
);
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*\d).{8,}$/;
export const contactNumberRegex = /^\+[1-9]{1}[0-9]{3,14}$/;
export const boolRegex = /^([Tt][Rr][Uu][Ee]|[Ff][Aa][Ll][Ss][Ee])$/;
export const valueUptoTwoDecimalRegex = /^-?\d+(\.\d{1,2})?$/;
